/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Shop_Tier_Discount_InvalidInputs */

const vi_error_shop_tier_discount_invalid = /** @type {(inputs: Error_Shop_Tier_Discount_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi tối đa ${i?.max}%, tối đa 2 chữ số thập phân.`)
};

/**

* @param {Error_Shop_Tier_Discount_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_discount_invalid = /** @type {((inputs: Error_Shop_Tier_Discount_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_Discount_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_discount_invalid(inputs)
});